import Clarity from '@microsoft/clarity';

export enum FormName {
  Apply = 'apply',
  OfferCode = 'offer_code',
  ReinstatementOfferCode = 'reinstatement_offer_code',
  StarlingOfferCode = 'starling_offer_code',
  VerificationCode = 'verification_code',
  ResendVerification = 'resend_verification',
  DocumentVerification = 'document_verification',
  DocumentVerificationInitiated = 'document_verification_initiated',
}

export enum ErrorType {
  // Apply form errors
  Validation = 'validation',
  ServerValidation = 'server_validation',
  StrategyError = 'strategy_error',
  ServiceUnavailable = 'service_unavailable',
  SubmissionFailed = 'submission_failed',

  // Offer code errors
  InvalidOffer = 'invalid_offer',

  // Verification errors
  IncorrectCode = 'incorrect_code',
  VerificationFailed = 'verification_failed',

  // Resend verification errors
  NoResult = 'no_result',
  ResendFailed = 'resend_failed',

  // Document verification errors
  ConsentDeclined = 'consent_declined',
  SdkError = 'sdk_error',
  LaunchFailed = 'launch_failed',
  LaunchException = 'launch_exception',
  TokenRequestFailed = 'token_request_failed',
}

export enum ApplicationOutcome {
  Approved = 'approved',
  Declined = 'declined',
  Locked = 'locked',
  Review = 'review',
  Canceled = 'canceled',
  DocumentVerificationRequired = 'document_verification_required',
  TooManyCancelledApplications = 'too_many_cancelled_applications',
  BorrowerLocked = 'borrower_locked',
  SessionExpired = 'session_expired',
  UnderMaintenance = 'under_maintenance',
  ProcessingTimeout = 'processing_timeout',
  OfferCodeExpired = 'offer_code_expired',
  OfferCodeUsed = 'offer_code_used',
  PreApprovedLocked = 'pre_approved_locked',
  AccountOpened = 'account_opened',
  AccountClosed = 'account_closed',
}

/**
 * Tracks form submission events in Clarity
 * @param formName - The name of the form from FormName enum
 * Event name will be: {formName}_submitted
 */
export const trackFormSubmission = (formName: FormName) => {
  const eventName = `${formName}_submitted`;

  Clarity.event(eventName);
};

/**
 * Tracks form error events in Clarity
 * @param formName - The name of the form from FormName enum
 * @param errorType - Error type from ErrorType enum for more specific tracking
 * Event name will be: {formName}_error{_errorType} (e.g., 'apply_error_validation', 'offer_code_error_code_expired')
 */
export const trackFormError = (formName: FormName, errorType?: ErrorType) => {
  const eventName = `${formName}_error${errorType ? `_${errorType}` : ''}`;

  Clarity.event(eventName);
};

/**
 * Tracks application outcome events in Clarity
 * @param outcome - The application outcome from ApplicationOutcome enum
 * Event name will be: application_{outcome} (e.g., 'application_approved', 'application_declined')
 */
export const trackApplicationOutcome = (outcome: ApplicationOutcome) => {
  const eventName = `application_${outcome}`;

  Clarity.event(eventName);
};
